

























































import { Component, Vue, Prop } from "vue-property-decorator";
import VoucherPrintVue from "@/components/Print/VoucherPrint.vue";
import { ipcRenderer } from "electron";
import { mapGetters } from "vuex";

@Component({
    ...mapGetters(["printers"]),
    components: {
        "voucher-print": VoucherPrintVue,
    },
})
export default class VoucherPrint extends Vue {
    @Prop({ type: Array })
    vouchers!: Voucher.Voucher[];

    printers: Electron.PrinterInfo[] = [];
    printer: Electron.PrinterInfo | null = null;
    way = localStorage.getItem("printWay") || 0;

    get voucherModel() {
        return this.$utils.pageableVoucher(this.$store.state.voucherRows, this.vouchers);
    }

    getLocalPrinters() {
        let vPrinter = localStorage.getItem("voucherPrinter");
        let sPrinter = localStorage.getItem("sheetPrinter");

        if (vPrinter != null) this.printer = JSON.parse(vPrinter);
    }

    changePrinter(printer: Electron.PrinterInfo) {
        if (this.$utils.notNull([printer])) {
            localStorage.setItem("voucherPrinter", JSON.stringify(printer));
        } else {
            localStorage.removeItem("voucherPrinter");
        }
    }

    async setArg() {
        let storage = await Vue.axios.get(
            `accounts/printer/set/find?accounterId=${this.$store.state.account.id}`
        );

        this.bookKeeper = storage.data.bookKeeper;
        this.teller = storage.data.teller;
        this.documentMaker = storage.data.documentMaker || this.$store.state.account.name;
    }

    mounted() {
        this.getLocalPrinters();
        this.setArg();
    }

    startPrint() {
        const topArea = <HTMLElement>this.$el.querySelector(".top-area");
        const voucherInner = (<HTMLElement>(
            topArea.querySelector(".voucher-wrap")
        )).innerHTML;
        // this.$utils.sendToElectron(
        //     "print-voucher",
        //     voucherInner,
        //     this.printer
        // );
        localStorage.setItem("print-area", voucherInner);
        window.open("/print.html");
        this.$emit("close");
    }

    margin = 34;
    padding = 30;
    horizontal = false;
    percent = 100;

    a4Voucher = false;
    lineHeight =
        localStorage.getItem("lh") === null
            ? 1.28
            : +(<string>localStorage.getItem("lh")) > 10 ? 1.28 : +(<string>localStorage.getItem("lh"));

    accounter = "";
    casher = "";
    writer = this.vouchers.length > 0 ? this.vouchers[0].writtenPerson : "";
    voucherFont = localStorage.getItem("voucherFont") === null
        ? 11
        : +(<string>localStorage.getItem("voucherFont"));
    bookKeeper = "";
    teller = "";
    documentMaker = "";
}
